export default "/dist/files/choose_picture.44d03ecaff3810eab62387fd3ff3a4fc.svg";